import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'


const styles = theme => ({
  error: {
    fontSize: 12,
    marginTop: 10,
    marginBottom: 10,
    color: theme.palette.error.main,
  },
  gradient: {
    fontSize: 48,
    marginLeft: 5,
    fontWeight: 700,
    lineHeight: '45px',
    color: 'transparent',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    background: 'linear-gradient(315deg, #007da9, #f02a64)',
  },
})


const ErrorTextUnstyled = ({
  classes,
  children,
  className,
  ...props
}) => (
    <Typography
      component="span"
      variant="body2"
      className={classNames(classes.error, className)}
      {...props}
    >
      {children}
    </Typography>
  )

ErrorTextUnstyled.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
}


const GradientTextUnstyled = ({
  classes,
  className,
  children,
  ...props
}) => (
    <Typography
      className={classNames(classes.gradient, className)}
      {...props}
    >
      {children}
    </Typography>
  )


GradientTextUnstyled.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export const ErrorText = withStyles(styles)(ErrorTextUnstyled)
export const GradientText = withStyles(styles)(GradientTextUnstyled)
